import { produce } from "immer";
import { AnyAction } from "redux";

import { AppointmentStatusSlug } from "../../../_constants/appointment.ts";
import { IService } from "../../serviceOrdering/reducers";
import { GET_SERVICES_SUCCESS } from "../constants";

export interface IResponseServices {
  services?: Array<IService>;
  count: number;
  currentPage: number;
}

export interface IResponsePaginateServices {
  services: Array<IService>;
  perPage: number;
  currentPage: number;
  firstPage: number;
  total: number;
  lastPage: number;
  totalCountServicesStatuses: {
    [AppointmentStatusSlug.PLANNING]: number;
    [AppointmentStatusSlug.WAITING_TENANT]: number;
    [AppointmentStatusSlug.PLANNED]: number;
    [AppointmentStatusSlug.FIRST_REMINDER]: number;
    [AppointmentStatusSlug.SECOND_REMINDER]: number;
    [AppointmentStatusSlug.CONFIRMED]: number;
    [AppointmentStatusSlug.DONE]: number;
    [AppointmentStatusSlug.TO_PROCESS]: number;
    [AppointmentStatusSlug.FINALIZED]: number;
    [AppointmentStatusSlug.CANCEL]: number;
  };
  hasSuperAdminPermission: boolean;
}

const initState = {
  service: null,
  services: null,
  servicesCount: null,
};

const ordersReducer = produce((draft = initState, action: AnyAction) => {
  switch (action.type) {
    case GET_SERVICES_SUCCESS:
      draft.services = action.payload.services;
      draft.servicesCount = action.payload.count;
      break;
    default:
      return draft;
  }
});

export default ordersReducer;
